exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".favorite-button[data-v-0f943fca]{cursor:pointer;display:inline-flex;align-items:center;justify-content:center;color:#000;transition:color .3s ease;background-color:#fff;padding:.2rem .4rem .4rem .2rem;border-radius:50%;width:2rem;height:2rem}.favorite-button .heart-path[data-v-0f943fca]{fill:#23201e}.favorite-button .heart-fill[data-v-0f943fca]{fill:none}.favorite-button.is-favorite[data-v-0f943fca]{color:#a1462b}.favorite-button.is-favorite .heart-path[data-v-0f943fca]{fill:#a1462b}.favorite-button.is-favorite .heart-fill[data-v-0f943fca]{fill:currentColor}.favorite-button[data-v-0f943fca]:hover{opacity:.8}", ""]);

// exports
